import React, {useState} from "react";
import UploadFilesForm from "../../../../components/form/UploadFilesForm";
import {constantsErrorMessages} from "../../../../Constants";

const UploadFilesRequestsForm = ({
                                     orderId,
                                     change,
                                     setChange,
                                     calculationRequestsCutting,
                                     checkModel,
                                     detail,
                                     uploadData,
                                     handleModalAlert,
                                     multiple,
                                     disableImport,
                                     setDisableImport,
                                     checkB3dExtension,
                                     importDetailSamplesGroup,
                                     beforeImport,
                                     label
                                 }) => {
    const [selectedFiles, setSelectedFiles] = useState([]);

    const handleUpload = async (event) => {
        event.preventDefault();
        const extension = selectedFiles[0].name.split('.')[1]
        if (extension !== "b3d" && checkB3dExtension) {
            handleModalAlert("Данный формат не поддерживается")
        } else if (importDetailSamplesGroup) {
            uploadData.upload && uploadData.upload(selectedFiles, importDetailSamplesGroup)
                .then(function (response) {
                    setChange(!change)
                    handleModalAlert(multiple ? "Файлы импортированы" : "Файл импортирован", 'success')
                    beforeImport(response.data)
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(function () {
                    event.target.reset();
                    setSelectedFiles([])
                })
        } else {
            uploadData.upload && uploadData.upload(selectedFiles, calculationRequestsCutting !== undefined ? calculationRequestsCutting : checkModel, orderId)
                .then(function () {
                    setChange(!change)
                    handleModalAlert(multiple ? "Файлы импортированы" : "Файл импортирован", 'success')
                    if (checkB3dExtension) {
                        setDisableImport(true)
                        setTimeout(() => setDisableImport(false), 10000);
                    }
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(function () {
                    event.target.reset();
                    setSelectedFiles([])
                })
        }

    }

    return (
        <div>
            <UploadFilesForm
                uploadData={uploadData}
                handleUpload={handleUpload}
                selectedFiles={selectedFiles}
                setSelectedFiles={setSelectedFiles}
                multiple={multiple}
                label={label || (checkB3dExtension ? "Импортировать 3D модель" : detail ? "Загрузить детали" : "Загрузить заявки на раскрой")}
                disableImport={disableImport}
            />
        </div>
    );
};

export default UploadFilesRequestsForm;